// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mp1hM","col":"styles_col__2F0IB"};